// extracted by mini-css-extract-plugin
module.exports = {"headerUserMenu":"_1mbNa","cartIcon":"_2JPqO"};